import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { CircleIcon } from 'components/elements/Icons';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function ProgressSubtitle({ title, children }) {
  const classes = useStyles();
  return (
    <div className={classes.progressSubtitle}>
      <CircleIcon classes={classes.circleIcon} />
      {children || (
        <Typography className={classes.capitalizedTitle} variant="h6" component="h6" noWrap>
          {title}
        </Typography>
      )}
    </div>
  );
}

ProgressSubtitle.propTypes = {
  title: PropTypes.string,
  children: PropTypes.element,
};

ProgressSubtitle.defaultProps = {
  children: null,
  title: '',
};

export default ProgressSubtitle;
